module.exports = __webpack_public_path__ + "static/media/clipboard.f0ea2796.svg";